module.exports = __webpack_public_path__ + "static/media/career_small.79062326.jpg";